import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = { class: "w-full mb-4" }
const _hoisted_3 = { class: "relative flex items-center w-full h-[22px] max-h-[22px] bg-[#f3f0e9] rounded-full p-[2px] border border-[#e8e2d8] select-none" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex flex-wrap gap-2 w-full justify-center" }
const _hoisted_7 = ["onClick", "onMouseover"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text-center text-[10px] leading-tight text-parameter-text" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "text-center text-[10px] leading-tight text-parameter-text" }
const _hoisted_12 = {
  key: 0,
  class: "w-full"
}
const _hoisted_13 = { class: "mt-4 w-full" }
const _hoisted_14 = {
  key: 0,
  class: "m-0 text-[15px] leading-5 font-normal text-parameter-title"
}
const _hoisted_15 = { class: "mt-1" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "block text-sm font-medium tracking-[0.1px] text-parameter-title" }
const _hoisted_20 = { class: "block truncate text-xs leading-[15px] text-parameter-text" }
const _hoisted_21 = { class: "block truncate text-xs leading-[15px] text-parameter-text" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_26 = ["aria-expanded"]
const _hoisted_27 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_28 = {
  key: 0,
  class: "flex gap-2 flex-wrap w-full justify-center"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "text-center text-[10px] leading-tight text-parameter-text w-full mx-auto" }
const _hoisted_32 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_33 = ["aria-expanded"]
const _hoisted_34 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_35 = {
  key: 0,
  class: "flex flex-wrap gap-2 w-full justify-center"
}
const _hoisted_36 = ["onClick", "onMouseover"]
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "text-center text-[10px] leading-tight text-parameter-text" }
const _hoisted_39 = ["onClick", "onMouseover"]
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "text-center text-[10px] leading-tight text-parameter-text" }
const _hoisted_42 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_43 = ["aria-expanded"]
const _hoisted_44 = { class: "flex items-center gap-1.5 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }
const _hoisted_45 = {
  key: 0,
  class: "flex divide-x divide-[#e7ddcc]"
}
const _hoisted_46 = { class: "w-1/2 px-4 first:pl-0 last:pr-0" }
const _hoisted_47 = { class: "flex items-center gap-2" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "flex-1 rounded-xl border border-[#e7ddcc] py-1.5 text-center text-xs font-medium text-parameter-title" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "relative mt-4 flex h-4 items-center select-none" }
const _hoisted_52 = { class: "pointer-events-none absolute inset-x-0 h-[3px] rounded-full bg-[#e7ddcc]" }
const _hoisted_53 = ["max", "value"]
const _hoisted_54 = { class: "mt-1 flex justify-between text-[10px] text-parameter-text" }
const _hoisted_55 = {
  key: 0,
  class: "w-1/2 px-4 first:pl-0 last:pr-0"
}
const _hoisted_56 = {
  key: 0,
  class: "overflow-hidden rounded-2xl border border-[#e7ddcc] bg-white"
}
const _hoisted_57 = {
  key: 0,
  class: "border-t border-[#e7ddcc] py-1"
}
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_60 = {
  key: 0,
  class: "m-0 text-center text-xs font-medium text-parameter-title"
}
const _hoisted_61 = { class: "relative mt-4 flex h-4 items-center select-none" }
const _hoisted_62 = { class: "pointer-events-none absolute inset-x-0 h-[3px] rounded-full bg-[#e7ddcc]" }
const _hoisted_63 = ["title"]
const _hoisted_64 = ["max", "value"]
const _hoisted_65 = { class: "w-full mt-2 h-20 overflow-hidden" }
const _hoisted_66 = ["src", "alt"]

import ItemV3ParameterBox from "@/components/itemV3/parameter/itemV3ParameterBox.vue";
import ItemV3RemoveGroupModal from "@/components/itemV3/parameter/itemV3RemoveGroupModal.vue";
import {computed, inject, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import {ParametersVariations} from "@/assets/ts/parametersVariations";
import {getCurrentText} from "@/assets/ts/itemText";

const imageWidthPercent: number = 30
const boxIdx = "grooves"

const variantIdx = "grooves.*.groove_type "


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3Grooves',
  props: ["item"],
  emits: ["patch"],
  setup(__props, { emit: __emit }) {


const {t} = useI18n();

const emit = __emit;
const props = __props;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

const loading = ref(false)

/**
 * Parameter box header images
 */

const mainMetal = computed(() => store.getters["session/getMainMetal"])
const getHeaderImage = (size: string = "600x300", withBg = false) => {
  if (withBg) {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${mainMetal.value}_${boxIdx}.webp`
  } else {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${boxIdx}.webp`
  }
}

/**
 * session
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])
const parametersVariations = new ParametersVariations(variantIdx, configureAll, session, itemIdx, loadItemVariants)

// Tracks the box's own open/closed state (bound via v-model:open below) instead of a
// hardcoded "false", so it survives re-renders triggered by a patch - see
// itemV3ParameterBox.vue's onUpdated hook, which re-asserts this value on every update.
const open = ref(false)

const currentGroovesText = computed(() => {
  return getCurrentText(configureAll.value ? -1 : itemIdx.value, variantIdx)
})

const grooves = computed(() => {
  const grooves: any = {}

  if (session.value && session.value.items && session.value.items[itemIdx.value]) {
    const firstItemVariants = session.value.items[itemIdx.value].variants || {};


    for (const key in firstItemVariants) {
      const variant = firstItemVariants[key];
      if (!variant?.idx) continue;

      let checkVariantId = variant.idx
      const parts = variant.idx.split('.');

      if (parts[0] != "grooves" || parts.length != 3) continue

      const grooveIdx = parseInt(parts[1].toString())
      const grooveIdxStr = "IDX" + grooveIdx

      if (typeof grooves[grooveIdxStr] == "undefined") {
        grooves[grooveIdxStr] = {
          "groove_idx": grooveIdx,
          "groove_type": "",
          "groove_width": 0,
          "groove_ampltute": 0,
          "object": "",
          "object_arrangement": "",
          "key": {}
        }
      }

      grooves[grooveIdxStr][parts[2]] = variant["text"]
      grooves[grooveIdxStr]["key"][parts[2]] = variant["key"] || ""

    }
  }

  //if (configureAll.value) {

  //}

  return grooves
})

/**
 * image
 */

const hoverGrooveTypeIdx = ref(-1)
const imageUrl = computed(() => {
  if (activeGroove.value.groove_type && activeGroove.value.groove_type.length > 0) {
    return parametersVariations.imageUrl(activeGroove.value.groove_type[0].values, hoverGrooveTypeIdx.value)
  } else {
    return parametersVariations.imageUrl([], -1)
  }
})


const hasGrooves = computed(() => Object.keys(grooves.value).length > 0)

/**
 * groove details
 */

const activeGrooveIdx = ref(-1)

const activeGroove = ref({
  "groove_type": {},
  "amplitude": {},
  "width": {},
  "object": {},
  "object_arrangement": {}
} as any)

const getActiveGrooveData = (grooveIdy: number) => {
  if (grooveIdy >= 0) {
    activeGroove.value.groove_type = {}
    activeGroove.value.width = {}
    activeGroove.value.object = {}
    activeGroove.value.object_arrangement = {}
    activeGroove.value.amplitude = {}
    // Mirrors itemV2GrooveConfigurator.vue's "activeGroove.grooveTypeVariant": the raw
    // "grooves.<n>.groove_type" variant, whose values are grouped by conf_groups (see
    // groupedGrooveTypeValues below, transferred from itemV2GrooveType.vue).
    activeGroove.value.groove_type = parametersVariations.getItemVariants(itemIdx.value, "grooves." + grooveIdy + ".groove_type")
    activeGroove.value.width = parametersVariations.getItemVariants(itemIdx.value, "grooves." + grooveIdy + ".width")
    activeGroove.value.object = parametersVariations.getItemVariants(itemIdx.value, "grooves." + grooveIdy + ".object")
    activeGroove.value.object_arrangement = parametersVariations.getItemVariants(itemIdx.value, "grooves." + grooveIdy + ".object_arrangement")
    activeGroove.value.amplitude = parametersVariations.getItemVariants(itemIdx.value, "grooves." + grooveIdy + ".amplitude")

  }
}

watch(activeGrooveIdx, () => {
  if (activeGrooveIdx.value >= 0) {
    getActiveGrooveData(activeGrooveIdx.value)
  }
  showObjectDropdown.value = false
})

watch(session, () => {
  if (activeGrooveIdx.value >= 0) {
    getActiveGrooveData(activeGrooveIdx.value)
  }
}, {deep: true})

const isVariantLoaded = (variant: any) => {
  return Array.isArray(variant) && (variant.length === 0 || (variant[0]?.values && variant[0].values.length > 0))
}

watch(activeGroove, () => {
  if (
      isVariantLoaded(activeGroove.value.groove_type) &&
      isVariantLoaded(activeGroove.value.width) &&
      isVariantLoaded(activeGroove.value.object) &&
      isVariantLoaded(activeGroove.value.object_arrangement) &&
      isVariantLoaded(activeGroove.value.amplitude)
  ) {
    loading.value = false
  } else {
    loading.value = true
  }
}, {deep: true})

/**
 * groove details - collapsible sections (open/closeable nodes)
 */

const openSections = reactive<Record<string, boolean>>({
  amplitude: false,
  groove_type: false,
  width: false,
  object: false,
})

const toggleSection = (key: string) => {
  openSections[key] = !openSections[key]
}

/**
 * groove switch (like disc select button)
 */

const grooveList = computed(() => Object.values(grooves.value))

const grooveTabIdx = computed(() => {
  if (activeGrooveIdx.value === -1) return 0
  const idx = grooveList.value.findIndex((groove: any) => groove.groove_idx === activeGrooveIdx.value)
  return idx === -1 ? 0 : idx + 1
})

const grooveSliderStyle = computed(() => {
  const count = grooveList.value.length + 1
  const width = 100 / count
  const left = grooveTabIdx.value * width

  return {
    width: `calc(${width}% - 4px)`,
    left: `calc(${left}% + 2px)`,
  }
})

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  value = (typeof value == "string") ? value : value.idx
  emit('patch', {
    action: actionIdx,
    value: value,
    certificated_diamond: value.certificated_diamond
  });
};

/**
 * groove details - width
 */

const widthValues = computed(() => activeGroove.value.width[0]?.values || [])

const widthIdx = computed(() => {
  const idx = widthValues.value.findIndex((v: any) => v.match)
  return idx === -1 ? 0 : idx
})

// local slider position, so dragging the handle only updates the UI - the api
// call is only sent once the user drops (releases) the slider, see onWidthRangeChange
const sliderWidthIdx = ref(0)

watch(widthIdx, (idx) => {
  sliderWidthIdx.value = idx
}, {immediate: true})

const widthSliderPercent = computed(() => {
  if (widthValues.value.length < 2) return 0
  return (sliderWidthIdx.value / (widthValues.value.length - 1)) * 100
})

const currentWidth = computed(() => widthValues.value[sliderWidthIdx.value])

const stepWidth = (delta: number) => {
  if (!activeGroove.value.width[0]) return
  const newIdx = widthIdx.value + delta
  if (newIdx < 0 || newIdx >= widthValues.value.length) return
  handleValuePatch(activeGroove.value.width[0].idx, widthValues.value[newIdx])
}

const onWidthRangeInput = (event: Event) => {
  sliderWidthIdx.value = parseInt((event.target as HTMLInputElement).value)
}

const onWidthRangeChange = (event: Event) => {
  if (!activeGroove.value.width[0]) return
  const idx = parseInt((event.target as HTMLInputElement).value)
  const value = widthValues.value[idx]
  if (value) handleValuePatch(activeGroove.value.width[0].idx, value)
}

const parseWidthTitle = (title: string) => {
  if (!title) return NaN
  const match = title.replace(',', '.').match(/[\d.]+/)
  return match ? parseFloat(match[0]) : NaN
}

const widthStepLabel = computed(() => {
  if (widthValues.value.length < 2) return ''
  const first = parseWidthTitle(widthValues.value[0]?.title)
  const second = parseWidthTitle(widthValues.value[1]?.title)
  if (isNaN(first) || isNaN(second)) return ''
  const step = Math.abs(second - first)
  return step.toFixed(2).replace(/0+$/, '').replace(/\.$/, '').replace('.', ',')
})

/**
 * groove details - object (Bezug)
 */

const showObjectDropdown = ref(false)

const currentObject = computed(() => (activeGroove.value.object[0]?.values || []).find((v: any) => v.match))

/**
 * groove details - object arrangement (Ausrichtung) - step slider
 *
 * Rendered as a step slider (like the width slider above): the title of the currently
 * selected position is shown above the track, and every entry in
 * activeGroove.value.object_arrangement[0].values is one step. Some steps may be
 * marked as not allowed/sendable by the API - those stay visible on the track but
 * can't be dragged onto/selected (see isArrangementDisabled).
 */

const arrangementValues = computed(() => activeGroove.value.object_arrangement[0]?.values || [])

const isArrangementDisabled = (value: any) => {
  return value?.disabled === true || value?.sendable === false || value?.selectable === false || value?.available === false
}

const arrangementIdx = computed(() => {
  const idx = arrangementValues.value.findIndex((v: any) => v.match)
  return idx === -1 ? 0 : idx
})

// local slider position, so dragging the handle only updates the UI - the api call is
// only sent once the user drops (releases) the slider, see onArrangementRangeChange
const sliderArrangementIdx = ref(0)

watch(arrangementIdx, (idx) => {
  sliderArrangementIdx.value = idx
}, {immediate: true})

const arrangementStepPercent = (idx: number) => {
  if (arrangementValues.value.length < 2) return 0
  return (idx / (arrangementValues.value.length - 1)) * 100
}

const arrangementSliderPercent = computed(() => arrangementStepPercent(sliderArrangementIdx.value))

const currentArrangement = computed(() => arrangementValues.value[sliderArrangementIdx.value])

// The image bucket only keeps one folder per object shape ("ring" / "disc"), not one per
// disc idx (e.g. "disc-1") - so a "disc-<id>" object idx is normalized down to "disc".
const arrangementImageObject = computed(() => {
  console.log(currentObject.value)
  const idx = currentObject.value?.idx?.toString() || ''
  return idx.toLowerCase().startsWith('disc') ? 'disc' : idx
})

const arrangementImageUrl = computed(() => {
  if (!arrangementImageObject.value || !currentArrangement.value?.idx) return ''
  return "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/object_arrangement/"
      + arrangementImageObject.value + "/256/" + currentArrangement.value.idx + ".webp"
})

const onArrangementRangeInput = (event: Event) => {
  sliderArrangementIdx.value = parseInt((event.target as HTMLInputElement).value)
}

const onArrangementRangeChange = (event: Event) => {
  if (!activeGroove.value.object_arrangement[0]) return
  const idx = parseInt((event.target as HTMLInputElement).value)
  const value = arrangementValues.value[idx]
  if (value && !isArrangementDisabled(value)) {
    handleValuePatch(activeGroove.value.object_arrangement[0].idx, value)
  } else {
    // dropped on a step that isn't allowed/sendable - snap back to the current selection
    sliderArrangementIdx.value = arrangementIdx.value
  }
}

/**
 * groove details - groove type grouping (transferred from itemV2GrooveType.vue's
 * "activeGroove.grooveTypeVariant" handling)
 *
 * groove_type values are grouped by value.conf_groups.idx: only the value with
 * conf_groups.group_head == true represents its group in the main "Fugenform" list.
 * Every value belonging to the currently selected group is shown again in the
 * "Verlauf" list - both lists patch the exact same variant idx.
 */

const grooveTypeValues = computed(() => activeGroove.value.groove_type[0]?.values || [])

const groupedGrooveTypeValues = computed(() => {
  const groups: Record<string, any[]> = {}
  grooveTypeValues.value.forEach((value: any, idx: number) => {
    const groupIdx = value.conf_groups?.idx ?? value.idx
    if (!groups[groupIdx]) groups[groupIdx] = []
    value.list_idx = idx
    groups[groupIdx].push(value)
  })
  return groups
})

// order of the groove type variants inside the "Fugenform" list - values whose idx
// doesn't match any of these keywords are sorted last (treated as "")
const grooveTypeOrderKeywords = ["u-groove", "v-groove", "bead-groove", "matt-groove", ""]

const getGrooveTypeOrderPriority = (value: any) => {
  const idx = value?.idx?.toString() ?? ""
  const priority = grooveTypeOrderKeywords.findIndex((keyword) => keyword !== "" && idx.includes(keyword))
  return priority === -1 ? grooveTypeOrderKeywords.length - 1 : priority
}

const grooveTypeGroupHeadValues = computed(() => {
  const headValues = Object.values(groupedGrooveTypeValues.value)
      .map((groupValues: any) => groupValues.find((v: any) => v.conf_groups?.group_head) || groupValues[0])
      .filter(Boolean)
  return [...headValues].sort((a, b) => getGrooveTypeOrderPriority(a) - getGrooveTypeOrderPriority(b))
})

const selectedGrooveTypeGroupIdx = computed<string | null>(() => {
  const matched = grooveTypeValues.value.find((v: any) => v.match)
  if (!matched) return null
  return matched.conf_groups?.idx ?? matched.idx ?? null
})

const selectedGrooveTypeGroupValues = computed(() => {
  if (selectedGrooveTypeGroupIdx.value === null) return []
  return groupedGrooveTypeValues.value[selectedGrooveTypeGroupIdx.value] || []
})

/**
 * edge
 */

const getEdgeGrooveHead = computed(() => {
  // return the active groove if match = true and conf_groups.idx = edge
  // if match = true groove is not conf_groups.idx = edge get the groove with the conf_groups.group_head = true and conf_groups.idx = edge
  const matched = grooveTypeValues.value.find((v: any) => v.match)
  if (!matched) return null
  if (matched.conf_groups?.idx === "edge") return matched
  return grooveTypeValues.value.find((v: any) => v.conf_groups?.group_head && v.conf_groups?.idx === "edge") ?? null
})

const isActiveGrooveEdge = computed(() => {
  return getEdgeGrooveHead.value?.match
})

const alternativeGrooveTypeGroupValues = computed(() => {
  if (selectedGrooveTypeGroupIdx.value === null) return []
  for (let grooveGroupIdx in groupedGrooveTypeValues.value) {
    if (grooveGroupIdx !== "edge") return groupedGrooveTypeValues.value[grooveGroupIdx]
  }
  return groupedGrooveTypeValues.value[selectedGrooveTypeGroupIdx.value] || []
})

const grooveVariantsList = computed(() => {
  if (isActiveGrooveEdge.value) {
    return alternativeGrooveTypeGroupValues.value
  } else {
    return selectedGrooveTypeGroupValues.value
  }
})


/**
 * images
 */

const getGrooveCloseup = (groove_type: string) => {
  const key = groove_type.toLowerCase()
  return "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/groove_type/600x600/" + key + ".webp"
}

const getGrooveForm = (groove_type: string) => {
  const key = groove_type.toLowerCase()
  return "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/groove_form/800x600/" + key + ".webp"
}

const getGrooveVariant = (groove_type: string) => {
  const key = groove_type.toLowerCase()
  return "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/groove_variant/800x600/" + key + ".webp"
}

const getAmplitudeCloseup = (amplitude: number) => {
  const key = Number(amplitude).toFixed(1).replace(".", "")
  return "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/amplitude/800x600/groove_amplitude_" + key + ".webp"
}

/**
 * remove groove
 */

const showRemoveModal = ref(false)
const grooveToRemove = ref<any>(null)

const confirmRemoveGroove = (groove: any) => {
  grooveToRemove.value = groove
  showRemoveModal.value = true
};

const grooveToRemoveName = computed(() => {
  return grooveToRemove.value ? `Fuge ${grooveToRemove.value.groove_idx + 1}` : ''
})

const handleRemoveGroove = () => {
  if (grooveToRemove.value) {
    handleValuePatch(`grooves.${grooveToRemove.value.groove_idx}.remove`, 'remove')
  }
  showRemoveModal.value = false
  grooveToRemove.value = null
};

/**
 * tip texts
 */

const getColorTipTitle = computed(() => {

  let key = "common"
  if (activeGroove.value.groove_type && activeGroove.value.groove_type.length > 0 && hoverGrooveTypeIdx.value != -1) {
    key = activeGroove.value.groove_type[0].values[hoverGrooveTypeIdx.value].idx
  }
  return t('components.parameters.tips.grooves.' + key + '.title')
})

const getColorTipText = computed(() => {
  let key = "common"
  if (activeGroove.value.groove_type && activeGroove.value.groove_type.length > 0 && hoverGrooveTypeIdx.value != -1) {
    key = activeGroove.value.groove_type[0].values[hoverGrooveTypeIdx.value].idx
  }
  return t('components.parameters.tips.grooves.' + key + '.text')
})

const getColorTipImageUrl = computed(() => {
  if (activeGroove.value.groove_type && activeGroove.value.groove_type.length > 0 && hoverGrooveTypeIdx.value != -1) {
    return getGrooveCloseup(activeGroove.value.groove_type[0].values[hoverGrooveTypeIdx.value].idx)
  }
  return "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/tips/grooves/300x300/common.webp"
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ItemV3ParameterBox, {
      open: open.value,
      "onUpdate:open": _cache[15] || (_cache[15] = ($event: any) => ((open).value = $event)),
      "image-width-percent": imageWidthPercent,
      image: imageUrl.value,
      "header-image": getHeaderImage(),
      "header-image-srcset": getHeaderImage() + ' 300w, ' + getHeaderImage('1200x600') +' 600w',
      title: "Fugen",
      subtitle: currentGroovesText.value || 'Mit oder ohne Fugen - und in welcher Ausführung?',
      loading: loading.value,
      "tip-title": getColorTipTitle.value,
      "tip-text": getColorTipText.value,
      "tip-image": getColorTipImageUrl.value
    }, {
      main: _withCtx(() => [
        (activeGrooveIdx.value != -1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("nav", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "absolute top-[2px] bottom-[2px] bg-brand-main rounded-full transition-all duration-300 ease-in-out shadow-xs pointer-events-none",
                    style: _normalizeStyle(grooveSliderStyle.value)
                  }, null, 4),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["text-[10px] tracking-wided relative flex-1 flex cursor-pointer items-center justify-center text-xs transition-colors duration-200 z-10 font-normal leading-none h-full", activeGrooveIdx.value === -1 ? 'text-white font-medium' : 'text-gray-500 hover:text-gray-700']),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (activeGrooveIdx.value = -1))
                  }, " Übersicht ", 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grooves.value, (groove, grooveKey) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: grooveKey,
                      type: "button",
                      class: _normalizeClass(["text-[10px] tracking-wided relative flex-1 flex cursor-pointer items-center justify-center text-xs transition-colors duration-200 z-10 font-normal leading-none h-full", activeGrooveIdx.value === groove.groove_idx ? 'text-white font-medium' : 'text-gray-500 hover:text-gray-700']),
                      onClick: ($event: any) => (activeGrooveIdx.value = groove.groove_idx)
                    }, " Fuge " + _toDisplayString(groove.groove_idx + 1), 11, _hoisted_4))
                  }), 128))
                ])
              ]),
              (selectedGrooveTypeGroupValues.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("ul", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grooveVariantsList.value, (grooveVariant, grooveVariantIdx) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: grooveVariantIdx,
                          class: "cursor-pointer flex flex-col items-center gap-1.5 w-15",
                          onClick: ($event: any) => (handleValuePatch(activeGroove.value.groove_type[0].idx, grooveVariant)),
                          onMouseover: ($event: any) => (hoverGrooveTypeIdx.value=grooveVariant.list_idx),
                          onMouseout: _cache[1] || (_cache[1] = ($event: any) => (hoverGrooveTypeIdx.value=-1))
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["flex aspect-retro shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-[#e7ddcc]", grooveVariant.match ? 'border-brand-main' : 'border-[#e7ddcc] hover:border-brand-main/50'])
                          }, [
                            _createElementVNode("img", {
                              src: getGrooveVariant(grooveVariant.idx),
                              alt: "",
                              class: "size-full aspect-retro object-cover"
                            }, null, 8, _hoisted_8)
                          ], 2),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(grooveVariant.text_variant), 1)
                        ], 40, _hoisted_7))
                      }), 128)),
                      (getEdgeGrooveHead.value)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            class: "cursor-pointer flex flex-col items-center gap-1.5 w-15",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleValuePatch(activeGroove.value.groove_type[0].idx, getEdgeGrooveHead.value.idx))),
                            onMouseover: _cache[3] || (_cache[3] = ($event: any) => (hoverGrooveTypeIdx.value=getEdgeGrooveHead.value.list_idx)),
                            onMouseout: _cache[4] || (_cache[4] = ($event: any) => (hoverGrooveTypeIdx.value=-1))
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["flex aspect-retro shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-[#e7ddcc]", getEdgeGrooveHead.value.match ? 'border-brand-main' : 'border-[#e7ddcc] hover:border-brand-main/50'])
                            }, [
                              _createElementVNode("img", {
                                src: getGrooveVariant(getEdgeGrooveHead.value.idx),
                                alt: "",
                                class: "size-full aspect-retro object-cover"
                              }, null, 8, _hoisted_10)
                            ], 2),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(getEdgeGrooveHead.value.text_form), 1)
                          ], 32))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (grooves.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["flex w-full items-center gap-3 rounded-2xl p-2 text-left transition-colors hover:bg-[#f3f0e9] bg-white border border-gray-200 cursor-pointer", !hasGrooves.value ? 'border-brand-main bg-[#f3f0e9]' : '']),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (handleValuePatch(`grooves.remove`, 'remove')))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-2xl border", !hasGrooves.value ? 'border-brand-main' : 'border-[#e7ddcc]'])
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("img", {
                          src: "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/groove_type/600x600/empty.webp",
                          alt: ""
                        }, null, -1)
                      ]))], 2),
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-sm font-medium tracking-[0.1px] text-parameter-title" }, "Ohne Fugen", -1))
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                (hasGrooves.value)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_14, "Ihre Fugen"))
                  : _createCommentVNode("", true),
                _createElementVNode("ul", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grooves.value, (groove, grooveIdx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: 'groove-' + grooveIdx,
                      class: "flex items-center gap-3 rounded-2xl p-2 transition-colors hover:bg-[#f3f0e9] bg-white border border-gray-200 cursor-pointer"
                    }, [
                      _createElementVNode("span", {
                        class: "flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-[#e7ddcc]",
                        onClick: ($event: any) => (activeGrooveIdx.value = groove.groove_idx)
                      }, [
                        _createElementVNode("img", {
                          src: getGrooveCloseup(groove.key.groove_type),
                          alt: ""
                        }, null, 8, _hoisted_17)
                      ], 8, _hoisted_16),
                      _createElementVNode("div", {
                        class: "min-w-0 flex-1",
                        onClick: ($event: any) => (activeGrooveIdx.value = groove.groove_idx)
                      }, [
                        _createElementVNode("span", _hoisted_19, "Fuge " + _toDisplayString(groove.groove_idx + 1), 1),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(groove.groove_type) + " · " + _toDisplayString(groove.width), 1),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(groove.object) + " · " + _toDisplayString(groove.object_arrangement), 1)
                      ], 8, _hoisted_18),
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex size-8 shrink-0 items-center justify-center rounded-full text-[#8f8a80] transition-colors hover:bg-white hover:text-brand-main",
                        title: "Bearbeiten",
                        onClick: ($event: any) => (activeGrooveIdx.value = groove.groove_idx)
                      }, [...(_cache[19] || (_cache[19] = [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "size-3.5",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                          _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4Z" })
                        ], -1)
                      ]))], 8, _hoisted_22),
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex size-8 shrink-0 items-center justify-center rounded-full text-[#8f8a80] transition-colors hover:bg-white hover:text-red-500",
                        title: "Entfernen",
                        onClick: ($event: any) => (confirmRemoveGroove(groove))
                      }, [...(_cache[20] || (_cache[20] = [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "size-3.5",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                          _createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
                        ], -1)
                      ]))], 8, _hoisted_23)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-2 flex w-full items-center justify-center gap-2 rounded-[11px] border border-dashed border-parameter-text py-3 text-xs font-medium tracking-[0.1px] text-parameter-text transition-colors hover:bg-[#f3f0e9] hover:text-brand-main cursor-pointer",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (handleValuePatch('grooves.0.add', 'add')))
                }, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "size-3",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "5",
                      x2: "12",
                      y2: "19"
                    }),
                    _createElementVNode("line", {
                      x1: "5",
                      y1: "12",
                      x2: "19",
                      y2: "12"
                    })
                  ], -1),
                  _createTextVNode(" Fuge hinzufügen ", -1)
                ]))])
              ])
            ], 64))
      ]),
      details: _withCtx(() => [
        (activeGrooveIdx.value != -1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", null, [
                (activeGroove.value.amplitude[0])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex w-full items-center gap-3 mb-2 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
                        "aria-expanded": openSections.amplitude,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleSection('amplitude')))
                      }, [
                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
                        _createElementVNode("span", _hoisted_27, [
                          _cache[23] || (_cache[23] = _createTextVNode(" Wellenhöhe ", -1)),
                          (_openBlock(), _createElementBlock("svg", {
                            "aria-hidden": "true",
                            viewBox: "0 0 12 12",
                            fill: "none",
                            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.amplitude ? 'rotate-180' : ''])
                          }, [...(_cache[22] || (_cache[22] = [
                            _createElementVNode("path", {
                              d: "m1.5 4 4.5 4 4.5-4",
                              stroke: "currentColor",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, null, -1)
                          ]))], 2))
                        ]),
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
                      ], 8, _hoisted_26),
                      (openSections.amplitude)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeGroove.value.amplitude[0].values, (grooveAmplitude, grooveAmplitudeIdx) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: grooveAmplitudeIdx,
                                onClick: ($event: any) => (handleValuePatch(activeGroove.value.amplitude[0].idx, grooveAmplitude)),
                                class: "cursor-pointer flex flex-col items-center gap-1.5 w-15"
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["flex w-full h-auto shrink-0 items-center justify-center overflow-hidden rounded-2xl border-2 border-[#e7ddcc] cursor-pointer", grooveAmplitude.match ? 'border-brand-main' : 'border-[#e7ddcc] hover:border-brand-main/50'])
                                }, [
                                  _createElementVNode("img", {
                                    src: getAmplitudeCloseup(grooveAmplitude.idx),
                                    alt: "",
                                    class: "size-full object-cover"
                                  }, null, 8, _hoisted_30)
                                ], 2),
                                _createElementVNode("span", _hoisted_31, _toDisplayString(grooveAmplitude.title), 1)
                              ], 8, _hoisted_29))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (activeGroove.value.groove_type[0])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex w-full items-center gap-3 mb-2 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
                        "aria-expanded": openSections.groove_type,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleSection('groove_type')))
                      }, [
                        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
                        _createElementVNode("span", _hoisted_34, [
                          _cache[27] || (_cache[27] = _createTextVNode(" Fugenform ", -1)),
                          (_openBlock(), _createElementBlock("svg", {
                            "aria-hidden": "true",
                            viewBox: "0 0 12 12",
                            fill: "none",
                            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.groove_type ? 'rotate-180' : ''])
                          }, [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("path", {
                              d: "m1.5 4 4.5 4 4.5-4",
                              stroke: "currentColor",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, null, -1)
                          ]))], 2))
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
                      ], 8, _hoisted_33),
                      (openSections.groove_type)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                            (isActiveGrooveEdge.value)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(selectedGrooveTypeGroupValues.value, (grooveVariant, grooveVariantIdx) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: grooveVariantIdx,
                                    class: "cursor-pointer flex flex-col items-center gap-1.5 w-15",
                                    onClick: ($event: any) => (handleValuePatch(activeGroove.value.groove_type[0].idx, grooveVariant)),
                                    onMouseover: ($event: any) => (hoverGrooveTypeIdx.value=grooveVariant.list_idx),
                                    onMouseout: _cache[9] || (_cache[9] = ($event: any) => (hoverGrooveTypeIdx.value=-1))
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["flex aspect-retro shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-[#e7ddcc]", grooveVariant.match ? 'border-brand-main' : 'border-[#e7ddcc] hover:border-brand-main/50'])
                                    }, [
                                      _createElementVNode("img", {
                                        src: getGrooveVariant(grooveVariant.idx),
                                        alt: "",
                                        class: "size-full aspect-retro object-cover"
                                      }, null, 8, _hoisted_37)
                                    ], 2),
                                    _createElementVNode("span", _hoisted_38, "aa" + _toDisplayString(grooveVariant.text_variant), 1)
                                  ], 40, _hoisted_36))
                                }), 128))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(grooveTypeGroupHeadValues.value, (grooveType, grooveTypeIdx) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (grooveType.conf_groups.idx != 'edge')
                                      ? (_openBlock(), _createElementBlock("li", {
                                          key: grooveTypeIdx,
                                          class: "cursor-pointer flex flex-col items-center gap-1.5 w-16",
                                          onClick: ($event: any) => (handleValuePatch(activeGroove.value.groove_type[0].idx, grooveType)),
                                          onMouseover: ($event: any) => (hoverGrooveTypeIdx.value=grooveType.list_idx),
                                          onMouseout: _cache[10] || (_cache[10] = ($event: any) => (hoverGrooveTypeIdx.value=-1))
                                        }, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["flex aspect-retro shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-[#e7ddcc]", grooveType.match ? 'border-brand-main' : 'border-[#e7ddcc] hover:border-brand-main/50'])
                                          }, [
                                            _createElementVNode("img", {
                                              src: getGrooveForm(grooveType.idx),
                                              alt: "",
                                              class: "size-full object-cover aspect-retro"
                                            }, null, 8, _hoisted_40)
                                          ], 2),
                                          _createElementVNode("span", _hoisted_41, _toDisplayString(grooveType.text_form), 1)
                                        ], 40, _hoisted_39))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 256))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (activeGroove.value.width[0])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex w-full items-center gap-3 mb-2 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
                        "aria-expanded": openSections.width,
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (toggleSection('width')))
                      }, [
                        _cache[32] || (_cache[32] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
                        _createElementVNode("span", _hoisted_44, [
                          _cache[31] || (_cache[31] = _createTextVNode(" Breite / Position ", -1)),
                          (_openBlock(), _createElementBlock("svg", {
                            "aria-hidden": "true",
                            viewBox: "0 0 12 12",
                            fill: "none",
                            class: _normalizeClass(["size-2.5 shrink-0 text-[#555956] transition-transform", openSections.width ? 'rotate-180' : ''])
                          }, [...(_cache[30] || (_cache[30] = [
                            _createElementVNode("path", {
                              d: "m1.5 4 4.5 4 4.5-4",
                              stroke: "currentColor",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, null, -1)
                          ]))], 2))
                        ]),
                        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
                      ], 8, _hoisted_43),
                      (openSections.width)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _cache[34] || (_cache[34] = _createElementVNode("h6", { class: "m-0 mb-2 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }, " Breite", -1)),
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full border border-[#e7ddcc] text-[#8f8a80] transition-colors hover:bg-[#f3f0e9] hover:text-brand-main disabled:cursor-not-allowed disabled:opacity-30",
                                  disabled: widthIdx.value <= 0,
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (stepWidth(-1)))
                                }, " − ", 8, _hoisted_48),
                                _createElementVNode("span", _hoisted_49, _toDisplayString(currentWidth.value?.title), 1),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full border border-[#e7ddcc] text-[#8f8a80] transition-colors hover:bg-[#f3f0e9] hover:text-brand-main disabled:cursor-not-allowed disabled:opacity-30",
                                  disabled: widthIdx.value >= widthValues.value.length - 1,
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (stepWidth(1)))
                                }, " + ", 8, _hoisted_50)
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("div", {
                                    class: "h-full rounded-full bg-brand-main",
                                    style: _normalizeStyle({ width: widthSliderPercent.value + '%' })
                                  }, null, 4)
                                ]),
                                _createElementVNode("div", {
                                  class: "pointer-events-none absolute top-1/2 size-4 rounded-full bg-brand-main shadow-md",
                                  style: _normalizeStyle({ left: widthSliderPercent.value + '%', transform: 'translate(-50%, -50%)' })
                                }, null, 4),
                                _createElementVNode("input", {
                                  type: "range",
                                  class: "absolute inset-0 z-10 h-full w-full cursor-pointer opacity-0",
                                  min: "0",
                                  max: widthValues.value.length - 1,
                                  step: "1",
                                  value: sliderWidthIdx.value,
                                  onInput: onWidthRangeInput,
                                  onChange: onWidthRangeChange
                                }, null, 40, _hoisted_53)
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("span", null, _toDisplayString(widthValues.value[0]?.title), 1),
                                _createElementVNode("span", null, _toDisplayString(widthValues.value[widthValues.value.length - 1]?.title), 1)
                              ])
                            ]),
                            (activeGroove.value.object[0] || activeGroove.value.object_arrangement[0])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                  _cache[36] || (_cache[36] = _createElementVNode("h6", { class: "m-0 mb-2 text-xs leading-[15px] font-normal tracking-[0.1px] text-parameter-text whitespace-nowrap" }, " Position", -1)),
                                  (activeGroove.value.object[0])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "flex w-full cursor-pointer items-center justify-between px-3 py-2 text-left text-xs text-parameter-title transition-colors hover:bg-[#f3f0e9]",
                                          onClick: _cache[14] || (_cache[14] = ($event: any) => (showObjectDropdown.value = !showObjectDropdown.value))
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(currentArrangement.value?.title) + " " + _toDisplayString(currentObject.value?.title), 1),
                                          (_openBlock(), _createElementBlock("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: _normalizeClass(["size-3.5 shrink-0 transition-transform", showObjectDropdown.value ? 'rotate-180' : '']),
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                          }, [...(_cache[35] || (_cache[35] = [
                                            _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                                          ]))], 2))
                                        ]),
                                        (showObjectDropdown.value)
                                          ? (_openBlock(), _createElementBlock("ul", _hoisted_57, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeGroove.value.object[0].values, (grooveObject, grooveObjectIdx) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                  key: grooveObjectIdx,
                                                  class: _normalizeClass(["mx-1.5 cursor-pointer rounded-xl px-2.5 py-2 text-xs transition-colors hover:bg-[#f3f0e9]", grooveObject.match ? 'bg-[#e7ddcc] font-medium text-parameter-title' : 'text-parameter-text']),
                                                  onClick: ($event: any) => {handleValuePatch(activeGroove.value.object[0].idx, grooveObject); showObjectDropdown.value = false}
                                                }, _toDisplayString(currentArrangement.value?.title) + " " + _toDisplayString(grooveObject.title), 11, _hoisted_58))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (activeGroove.value.object_arrangement[0])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                        false
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(currentArrangement.value?.title), 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_61, [
                                          _createElementVNode("div", _hoisted_62, [
                                            _createElementVNode("div", {
                                              class: "h-full rounded-full bg-brand-main",
                                              style: _normalizeStyle({ width: arrangementSliderPercent.value + '%' })
                                            }, null, 4)
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrangementValues.value, (grooveObjectArrangement, grooveObjectArrangementIdx) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: grooveObjectArrangementIdx,
                                              title: grooveObjectArrangement.title,
                                              class: _normalizeClass(["pointer-events-none absolute top-1/2 size-1.5 rounded-full", isArrangementDisabled(grooveObjectArrangement) ? 'bg-[#c9c2b3]' : 'border border-brand-main bg-white']),
                                              style: _normalizeStyle({ left: arrangementStepPercent(grooveObjectArrangementIdx) + '%', transform: 'translate(-50%, -50%)' })
                                            }, null, 14, _hoisted_63))
                                          }), 128)),
                                          _createElementVNode("div", {
                                            class: "pointer-events-none absolute top-1/2 size-4 rounded-full bg-brand-main shadow-md",
                                            style: _normalizeStyle({ left: arrangementSliderPercent.value + '%', transform: 'translate(-50%, -50%)' })
                                          }, null, 4),
                                          _createElementVNode("input", {
                                            type: "range",
                                            class: "absolute inset-0 z-10 h-full w-full cursor-pointer opacity-0",
                                            min: "0",
                                            max: arrangementValues.value.length - 1,
                                            step: "1",
                                            value: sliderArrangementIdx.value,
                                            onInput: onArrangementRangeInput,
                                            onChange: onArrangementRangeChange
                                          }, null, 40, _hoisted_64)
                                        ]),
                                        _createElementVNode("div", _hoisted_65, [
                                          (arrangementImageUrl.value)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: arrangementImageUrl.value,
                                                alt: currentArrangement.value?.title || '',
                                                class: "aspect-square w-full max-w-44 -rotate-90 object-contain relative -top-1/2 mx-auto"
                                              }, null, 8, _hoisted_66))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }, null, -1))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open", "image", "header-image", "header-image-srcset", "subtitle", "loading", "tip-title", "tip-text", "tip-image"]),
    _createVNode(ItemV3RemoveGroupModal, {
      modelValue: showRemoveModal.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((showRemoveModal).value = $event)),
      "item-name": grooveToRemoveName.value,
      onConfirm: handleRemoveGroove
    }, null, 8, ["modelValue", "item-name"])
  ], 64))
}
}

})